// Security pre-screen REST client.
//
// Previously this returned a fixed four-control result (AC-2, AU-2, SC-13, IR-4)
// whenever the request failed — which was always, because BASE resolved to "" and
// the endpoint did not exist. Every demand got the same "risk: M" verdict and it
// looked like an assessment. Now on the shared client, and errors propagate.

import { get, post, demandPath, AI_TIMEOUT_MS } from "../../../api/http";

/** Previously-saved intake + result, so the form reopens with what was submitted. */
export async function getSecurity(demandId) {
  return get(demandPath(demandId, "/security"));
}

/**
 * Run the pre-screen. -> { summary: {risk, prescreen_pass, environment}, controls, gaps, rationale }
 *
 * The server persists the result and evaluates a fixed NIST 800-53 baseline, so the
 * control set is the same for every demand rather than whatever the model returned.
 */
export async function runSecurityPrescreen(demandId, payload) {
  return post(demandPath(demandId, "/security/prescreen"), payload, { timeout: AI_TIMEOUT_MS });
}
